import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from "vue";
import {MoneyFormatFilter} from "@/models/filters/money";
import {CurrencyCode, frontofficeCurrencyFilter} from "@/models/core/currency";
import {
  filterCryptoInfoDataByCurrency,
  useUserCryptoAccountsInfoMod,
} from "@/views/pages/finance/accounts/accountspage";


export default /*#__PURE__*/_defineComponent({
  __name: 'BitcoinIncomingInfo',
  props: {
  currency: {
    type: String,
    required: true,
  },
  address: {
    type: String,
    required: false,
    default: null
  },
  showAll: {
    type: Boolean,
    required: false,
    default: false
  },
},
  setup(__props) {

const props = __props;



const currency = computed(() => {
  return props.currency
})
const address = computed(() => {
  return props.address
})

const cryptoInfo = useUserCryptoAccountsInfoMod();

const cryptoInfoCurrencyData = computed(() => {
  if (!cryptoInfo.data?.value) return null;

  return filterCryptoInfoDataByCurrency( cryptoInfo.data?.value, currency.value as CurrencyCode );
})

const hasIncomingData = computed(() => {
  return cryptoInfoCurrencyData.value
    && cryptoInfoCurrencyData.value?.incomingInfo
    && cryptoInfoCurrencyData.value?.incomingInfo?.length > 0;
})

const showAll = computed(() => {
  return props.showAll;
})

const incomingTransactions = computed(() => {
  return cryptoInfoCurrencyData.value.incomingInfo ? cryptoInfoCurrencyData.value?.incomingInfo.filter((details) => {
    return (currency.value === details.currency)
    && (showAll.value || (address.value && (details.wallet === address.value)));
  }) : [];
})


return { __sfc: true,props, currency, address, cryptoInfo, cryptoInfoCurrencyData, hasIncomingData, showAll, incomingTransactions, MoneyFormatFilter, frontofficeCurrencyFilter }
}

})